const baseURL = "/v1/Inicio";

const service = {
  methods: {
    $salvarConteudoSecoes(body) {
      return this.$api().put(`${baseURL}/SecoesNew`, body);
    },
    $obterConteudoSecoes(params) {
      return this.$api().get(`${baseURL}/Secoes`, params);
    },
    $obterPerguntasFaq(params) {
      return this.$api().get(`${baseURL}/Faq`, params);
    },
    $obterImagem(params) {
      return this.$api().get(`${baseURL}/ObterImagem`, params);
    },
    $salvarImagem(params) {
      return this.$api().post(`${baseURL}/SalvarImagem`, params);
    },
  },
};

export default service;
